import React from 'react'
import { useTranslation } from 'react-i18next'
import './RejectedPageUk.scss'

export const RejectedPageUk = () => {
    const { t } = useTranslation()

    return (
        <div className="rejected-page-uk">
            <div className="rejected-page-uk-content">
                <div className="rejected-page-uk-text">
                    <h1>{t('RejectedPageHeader')}</h1>

                    <p>{t('RejectedPageIntroduction')}</p>

                    <p>{t('RejectedPageExplanation')}</p>

                    <p>
                        {t('RejectedPageSincerely')}
                        <br />
                        {t('RejectedPageCompany')}
                    </p>

                    <button
                        type="button"
                        className="btn btn-primary rejected-page-uk-button"
                    >
                        {t('BackToHomepage')}
                    </button>
                </div>
            </div>
        </div>
    )
}